<template>
  <div class="top8">

    <!-- Hero -->
    <header class="top8__hero">
      <div class="top8__hero-bg"></div>
      <div class="top8__hero-vignette"></div>
      <div class="top8__hero-rays"></div>

      <div class="top8__hero-inner">
        <!-- Badge -->
        <div class="top8__hero-badge">
          <span class="top8__hero-badge-dot">
            <span class="top8__hero-badge-ping"></span>
          </span>
          Top 8 Vantage
        </div>

        <!-- Trophy icon -->
        <div class="top8__hero-icon-wrap">
          <i class="fas fa-trophy top8__hero-icon"></i>
        </div>

        <h1 class="top8__hero-title">{{ $t('blog.top8Vantage.heroTitle') }}</h1>
        <h2 class="top8__hero-subtitle">{{ $t('blog.top8Vantage.heroSubTitle') }}</h2>
        <p class="top8__hero-lead">{{ $t('blog.top8Vantage.heroLead') }}</p>

        <a href="#meaning" class="top8__hero-btn">
          <i class="fas fa-arrow-down"></i>
          {{ $t('blog.top8Vantage.heroMore') }}
        </a>
      </div>

      <!-- Wave -->
      <div class="top8__hero-wave">
        <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path d="M0 80L60 65C120 50 240 20 360 10C480 0 600 0 720 7.5C840 15 960 30 1080 37.5C1200 45 1320 45 1380 45L1440 45V80H0Z" fill="#f2f0ea"/>
        </svg>
      </div>
    </header>

    <!-- Meaning -->
    <section id="meaning" class="top8__section top8__section--cream">
      <div class="top8__shell">

        <!-- Achievement banner -->
        <div class="top8__achievement">
          <h3 class="top8__achievement-title">{{ $t('blog.top8Vantage.achievementBannerTitle') }}</h3>
          <p class="top8__achievement-sub">{{ $t('blog.top8Vantage.achievementBannerSubtitle') }}</p>
          <div
            class="top8__achievement-img"
            @click="openImageModal({ src: 'https://songhancapital.com/assets/image/banner_8.png', caption: $t('blog.top8Vantage.achievementBannerTitle') })"
          >
            <img src="https://songhancapital.com/assets/image/banner_8.png" alt="SHC Top 8 Vantage" />
          </div>
        </div>

        <!-- Meaning list -->
        <div class="top8__section-header">
          <h2 class="top8__section-title">{{ $t('blog.top8Vantage.meaningTitle') }}</h2>
          <div class="top8__divider"></div>
        </div>

        <div class="top8__card">
          <ul class="top8__check-list">
            <li><i class="fas fa-check-circle"></i><span>{{ $t('blog.top8Vantage.meaning1') }}</span></li>
            <li><i class="fas fa-check-circle"></i><span>{{ $t('blog.top8Vantage.meaning2') }}</span></li>
            <li><i class="fas fa-check-circle"></i><span v-html="$t('blog.top8Vantage.meaning3')"></span></li>
            <li><i class="fas fa-check-circle"></i><span v-html="$t('blog.top8Vantage.meaning4')"></span></li>
          </ul>
        </div>

      </div>
    </section>

    <!-- System -->
    <section class="top8__section top8__section--white">
      <div class="top8__shell">
        <div class="top8__section-header">
          <h2 class="top8__section-title">{{ $t('blog.top8Vantage.systemTitle') }}</h2>
          <p class="top8__section-sub">{{ $t('blog.top8Vantage.systemLead') }}</p>
        </div>

        <div class="top8__grid-2">
          <!-- Operations -->
          <div class="top8__card">
            <h3 class="top8__card-title">
              <i class="fas fa-robot"></i>
              {{ $t('blog.top8Vantage.operationTitle') }}
            </h3>
            <ul class="top8__dot-list">
              <li><i class="fas fa-circle"></i>{{ $t('blog.top8Vantage.op1') }}</li>
              <li><i class="fas fa-circle"></i>{{ $t('blog.top8Vantage.op2') }}</li>
              <li><i class="fas fa-circle"></i>{{ $t('blog.top8Vantage.op3') }}</li>
              <li><i class="fas fa-circle"></i>{{ $t('blog.top8Vantage.op4') }}</li>
              <li><i class="fas fa-circle"></i>{{ $t('blog.top8Vantage.op5') }}</li>
            </ul>
          </div>

          <!-- Viewpoint -->
          <div class="top8__card">
            <h3 class="top8__card-title">
              <i class="fas fa-compass"></i>
              {{ $t('blog.top8Vantage.viewpointTitle') }}
            </h3>
            <div class="top8__viewpoint">
              <p><strong>{{ $t('blog.top8Vantage.viewpointLine1') }}</strong></p>
              <p><strong>{{ $t('blog.top8Vantage.viewpointLine2') }}</strong></p>
              <div class="top8__viewpoint-target">
                <i class="fas fa-bullseye"></i>
                <p v-html="$t('blog.top8Vantage.targetText')"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Audience + Join -->
    <section class="top8__section top8__section--cream">
      <div class="top8__shell">
        <div class="top8__grid-2">

          <!-- For who -->
          <div class="top8__card">
            <h2 class="top8__card-h2">{{ $t('blog.top8Vantage.forWhoTitle') }}</h2>
            <ul class="top8__check-list">
              <li><i class="fas fa-check"></i><span>{{ $t('blog.top8Vantage.forWho1') }}</span></li>
              <li><i class="fas fa-check"></i><span>{{ $t('blog.top8Vantage.forWho2') }}</span></li>
              <li><i class="fas fa-check"></i><span>{{ $t('blog.top8Vantage.forWho3') }}</span></li>
              <li><i class="fas fa-hands-helping"></i><span>{{ $t('blog.top8Vantage.forWho4') }}</span></li>
            </ul>
          </div>

          <!-- How to join -->
          <div class="top8__card">
            <h2 class="top8__card-h2">{{ $t('blog.top8Vantage.howToJoinTitle') }}</h2>
            <ol class="top8__ordered-list">
              <li v-html="$t('blog.top8Vantage.joinStep1')"></li>
              <li v-html="$t('blog.top8Vantage.joinStep2')"></li>
            </ol>

            <div class="top8__help-note">
              <p>{{ $t('blog.top8Vantage.helpNote') }}</p>
            </div>

            <div class="top8__join-actions">
              <a
                href="https://vigco.co/la-com/vi/SHCcapital"
                target="_blank"
                rel="noopener noreferrer"
                class="top8__join-btn top8__join-btn--primary"
              >
                <i class="fas fa-external-link-alt"></i>
                {{ $t('blog.top8Vantage.openAccountBtn') }}
              </a>
              <button class="top8__join-btn top8__join-btn--secondary" @click="goToContact">
                <i class="fas fa-comments"></i>
                {{ $t('blog.top8Vantage.contactBtn') }}
              </button>
            </div>

            <div class="top8__referral">
              <p v-html="$t('blog.top8Vantage.openAccountReferral')"></p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- Image modal -->
    <div v-if="showImageModal" class="top8__modal" @click="closeImageModal">
      <div class="top8__modal-box" @click.stop>
        <button class="top8__modal-close" @click="closeImageModal"><i class="fas fa-times"></i></button>
        <img v-if="selectedImage.src" :src="selectedImage.src" :alt="selectedImage.caption || ''" class="top8__modal-img" />
      </div>
    </div>

  </div>
</template>

<script src="./top8-vantage.js"></script>
<style src="./top8-vantage.scss" lang="scss"></style>
